/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Fisify API
 * OpenAPI spec version: 1.0.0
 */

export type AnalyticsEventType = typeof AnalyticsEventType[keyof typeof AnalyticsEventType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsEventType = {
  user_logout: 'user_logout',
  opened_fisify: 'opened_fisify',
  personalized_program_created: 'personalized_program_created',
  session_completed: 'session_completed',
  session_started: 'session_started',
  pill_started: 'pill_started',
  pill_completed: 'pill_completed',
  coach_consult_started: 'coach_consult_started',
  coach_consult_completed: 'coach_consult_completed',
  webinar_joined: 'webinar_joined',
  webinar_disjoined: 'webinar_disjoined',
  webinar_attended: 'webinar_attended',
  friend_request_sent: 'friend_request_sent',
  friend_request_cancelled: 'friend_request_cancelled',
  friend_request_accepted: 'friend_request_accepted',
  friend_request_rejected: 'friend_request_rejected',
  friend_deleted: 'friend_deleted',
  prize_info_requested: 'prize_info_requested',
  prize_winner_button_clicked: 'prize_winner_button_clicked',
  opened_physio_platform: 'opened_physio_platform',
  clinic_created: 'clinic_created',
  clinic_updated: 'clinic_updated',
  clinic_deleted: 'clinic_deleted',
  invitation_link_button_clicked: 'invitation_link_button_clicked',
  invitation_sent: 'invitation_sent',
  invitation_opened: 'invitation_opened',
  patient_added: 'patient_added',
  patient_deleted: 'patient_deleted',
  rehab_plan_program_sent: 'rehab_plan_program_sent',
  rehab_plan_program_updated: 'rehab_plan_program_updated',
  templates_folder_created: 'templates_folder_created',
  templates_folder_edited: 'templates_folder_edited',
  templates_folder_deleted: 'templates_folder_deleted',
  templates_container_created: 'templates_container_created',
  templates_container_edited: 'templates_container_edited',
  templates_container_deleted: 'templates_container_deleted',
  templates_template_created: 'templates_template_created',
  templates_template_deleted: 'templates_template_deleted',
  templates_template_used: 'templates_template_used',
  chat_message_sent: 'chat_message_sent',
  profile_updated: 'profile_updated',
  password_recovery_requested: 'password_recovery_requested',
  password_reset: 'password_reset',
} as const;
